import { useEffect, useState } from "react";
import { Activity, MailWarning } from "lucide-react";
import { Button, Dialog, DialogTrigger, Popover } from "react-aria-components";
import { formatHypothesisTitle } from "@tellem/ui";

type RecentMailing = {
  id: string;
  name: string;
  hypothesis_title: string;
  lifecycle_status: string;
  queued: number;
  sent: number;
  failed: number;
  bounced: number;
  next_send_at: string | null;
  last_activity_at: string | null;
};

export function MailingHeaderSummary({
  projectId,
  refreshKey,
  onOpen,
}: {
  projectId: string;
  refreshKey: number;
  onOpen: () => void;
}) {
  const [summary, setSummary] = useState<{
    activeCount: number;
    recent: RecentMailing[];
  }>({ activeCount: 0, recent: [] });
  useEffect(() => {
    if (!projectId) return;
    const controller = new AbortController();
    fetch(`/api/projects/${projectId}/mailings/header-summary`, {
      signal: controller.signal,
    })
      .then((response) => {
        if (!response.ok) throw new Error("SUMMARY_UNAVAILABLE");
        return response.json() as Promise<typeof summary>;
      })
      .then(setSummary)
      .catch(() => undefined);
    return () => controller.abort();
  }, [projectId, refreshKey]);
  const recent = summary.recent.filter((item) => item.lifecycle_status !== "archived").slice(0, 4);
  const hasErrors = recent.some((item) => item.failed + item.bounced > 0);
  return (
    <div className="mailing-header-summary">
      <DialogTrigger>
        <Button
          className={`mailing-header-chip mailing-header-chip-wide${hasErrors ? " error" : ""}`}
          aria-label={`Рассылки. Активных: ${summary.activeCount}`}
        >
          <Activity size={15} />
          <span>Рассылки</span>
          <b>{summary.activeCount}</b>
          {hasErrors && <MailWarning size={15} />}
        </Button>
        <Popover className="mailing-header-popover" placement="bottom end">
          <Dialog aria-label="Активные рассылки">
            <header>
              <strong>Активные</strong>
              <span>{summary.activeCount}</span>
            </header>
            {recent.map((item) => (
                <Button key={item.id} onPress={onOpen}>
                  <strong>
                    {formatHypothesisTitle(item.hypothesis_title)}
                  </strong>
                  <small>
                    {item.sent} отправлено · {item.queued} в очереди · {item.failed + item.bounced} ошибок
                  </small>
                </Button>
              ))}
            {!summary.activeCount && <p>Активных нет.</p>}
          </Dialog>
        </Popover>
      </DialogTrigger>
    </div>
  );
}
